const register = {
  loginCredentials: "Credenziali di accesso", // translated
  companyInformation: "Informazioni aziendali", // translated
  contactDetails: "Dettagli del contatto", // translated
  businessName: "Nome commerciale", // translated
  businessAddress: "Recapito di lavoro", // translated
  registrationCode: "Codice di registrazione", // translated
  websiteUrl: "URL del sito", // translated
  mobilePhone: "Cellulare", // translated
  regionStateProvince: "Regione/Stato/Provincia", // translated
  legalTitle: "Titolo legale", // translated
  city: "Città", // translated
  postalCode: "Codice Postale", // translated
  registrationSuccess: "Registrazione avvenuta.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome: "Attendi qualche istante e verrai reindirizzato alla home page.", // translated
};

export default register;
